// extracted by mini-css-extract-plugin
export default {"main":"LoginPage_main__HxfBj","container":"LoginPage_container__FpSna","left":"LoginPage_left__OA-aI","right":"LoginPage_right__52f6C"};